import {createSelector} from '@ngrx/store';

import * as fromWardsReducer from './wards.reducer'
import {AppState} from 'src/app/store/reducers';


export const currentState = (state: AppState) => (state[fromWardsReducer.wardsesFeatureKey]);

export const selectAllWards = createSelector(currentState, fromWardsReducer.selectAll);

export const selectTotalWards = createSelector(currentState, fromWardsReducer.selectTotal);

export const selectModifiedWards = createSelector(selectAllWards, (wards) => {
  return wards.map((ward) => {
    return {
      ...wards
    };
  });
});
